import React,{ useMemo } from "react"
import { graphql } from "gatsby"
import SortList from "../componets/SortList"
import Helmet from "react-helmet"

const Replay = ({ data }) => {

  const listData = useMemo(() => {
    return data.replayData.nodes.map((item) => {
      let hashTag = []
      item.replaySessionStyle.split(' ').forEach((tag,index) => {
        if(tag.replace('#','') != "")
          hashTag.push(tag.replace('#',''))
      })
      return {
        replayHashTag : hashTag,
        ...item
      }
    });
  },[data])

  return (
    <>
    <Helmet
      htmlAttributes={{
          lang: 'zh',
      }}
      title="TRPG Braves' Bar - 團錄閱覽"
      meta={[
          { name: 'description', content: `「歡迎來到TRPG Braves' Bar，要來杯燃燒龍舌蘭嗎？」「這裡是各個世界冒險者們稍做休息，並且將他們的故事流傳下去的地方。」         
          「今天，您也有故事想要分享，對吧？」` },
          { name: 'keywords', content: 'TRPG,團錄閱覽,台灣' }
      ]}
  />
    <SortList type={"replay"} list={{
      tagList : data.tagList.list, 
      systemList : data.replayData.systemList,
      gmList : data.replayData.gmList,
      scenarioAuthorList : data.replayData.scenarioAuthorList,
      formatList : data.replayData.formatList,
      nodes: listData
    }}/>
    </>
  );
  
}

export const query = graphql`
  query ReplayQuery {
    replayData : allGoogleSheetReplayDataRow(filter: {replayAgreement: {eq: "同意"}}, sort: {fields: replayTimestamp, order: DESC}) {
      nodes {
        replayFootnote
        replayGm
        replayLink
        replayHouserules
        replayPlayersName
        replayScenarioAuthor
        replayScenarioDescription
        replayScenarioName
        replayScenarioSource
        replaySessionFormat
        replaySessionStyle
        replaySystemName
        replayThumbnail
        replayTimestamp
      }
      systemList : distinct(field: replaySystemName)
      gmList : distinct(field: replayGm)
      scenarioAuthorList : distinct(field: replayScenarioAuthor)
      formatList : distinct(field: replaySessionFormat)
    }
    tagList: allGoogleSheetReplayTagDataRow {
      list : distinct(field: replayTag)
    }
  }
`

export default Replay;
